import {createContext} from 'react';
import {BasicNoMatchComponent} from './components/BasicNoMatchComponent';

export const BIO_FEATURE_NAMES = [
  // Enable weave remote execution
  'weave-backend' as const,
  // Enable the hoerable weave panel2 dev popup
  'weave-devpopup' as const,
  // Enable weave plot planel
  'weave-plot' as const,
  // Enable run queues
  'instant replay' as const,
  // Enable super secret easter egg
  'unicorn-plot' as const,
  // Enable Model Registry
  'model-registry' as const,
];
export type BioFeatureName = typeof BIO_FEATURE_NAMES[number];

export type WeaveAppState = {
  [featureName in BioFeatureName]: boolean;
} & {
  noMatchComponentType: typeof BasicNoMatchComponent;
};

const defaultState: any = {};
for (const key of BIO_FEATURE_NAMES) {
  defaultState[key] = false;
}
defaultState.noMatchComponentType = BasicNoMatchComponent;

export const WeaveAppContext = createContext<WeaveAppState>(
  defaultState as WeaveAppState
);

export default WeaveAppContext;
